import { Shadows } from "@mui/material";

export const SHADOWS_OVERRIDES: Shadows = [...(new Array<string>(25).fill("none") as Shadows)];
